import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'KpCell',
  props: {
  kp: Number,
  color: {
    type: String,
    default: 'black'
  },
  active: Boolean
},
  setup(__props) {

_useCssVars(_ctx => ({
  "01d9e250": (__props.color)
}))



return (_ctx: any,_cache: any) => {
  return (__props.kp !== undefined && __props.kp !== null)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["ms-text-secondary NKT-P1", { deactivated: !__props.active }])
      }, " KP: " + _toDisplayString(__props.kp?.toFixed(2)), 3))
    : _createCommentVNode("", true)
}
}

})